export enum StatusName {
  Ready = "Ready",
  InProgress = "In Progress",
  Waiting = "Waiting",
  Completed = "Completed",
  Scheduled = "Scheduled",
  trial = "trial",
}
